export const SHOWN_IN_CONVERSATION = ['text', 'file', 'close-request'];

export function shownInConversation(messages) {
    return messages.filter(message => SHOWN_IN_CONVERSATION.includes(message.type));
}

export function closeRequestText(content, isWorkfixLine, asker = 'You') {
    if (content == 'helped') {
        return 'The employee says they were helped';
    }

    if (content == '1') {
        return isWorkfixLine ? `${asker} asked if we helped` : `${asker} requested to archive the conversation`;
    }

    if (content == '0') {
        return isWorkfixLine ? 'The employee says they were not helped' : 'Request to archive conversation was rejected';
    }

    return '';
}

export function previewOf(message, isWorkfixLine, asker) {
    if (!message) {
        return '';
    }

    if (message.type === 'text') {
        return message.content;
    }

    if (message.type === 'file') {
        return 'File';
    }

    return message.type === 'close-request' ? closeRequestText(message.content, isWorkfixLine, asker) : '';
}
